import { render, staticRenderFns } from "./pcTabs.vue?vue&type=template&id=ef7d6dfe&scoped=true"
import script from "./pcTabs.vue?vue&type=script&lang=js"
export * from "./pcTabs.vue?vue&type=script&lang=js"
import style0 from "./pcTabs.vue?vue&type=style&index=0&id=ef7d6dfe&prod&scoped=true&lang=scss"
import style1 from "./pcTabs.vue?vue&type=style&index=1&id=ef7d6dfe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef7d6dfe",
  null
  
)

export default component.exports